import { render, staticRenderFns } from "./MailingEmailsList.vue?vue&type=template&id=5d003b31&"
import script from "./MailingEmailsList.vue?vue&type=script&lang=js&"
export * from "./MailingEmailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports